import type { FilterDefinition } from '@/components/filters/list-filter-types'

export function resolveFilterDefs<TFilters, TCtx>(
  keys: readonly string[],
  definitionsByKey: Map<string, FilterDefinition<TFilters, TCtx>>,
  ctx: TCtx,
): FilterDefinition<TFilters, TCtx>[] {
  return keys
    .map((key) => definitionsByKey.get(key))
    .filter((def): def is FilterDefinition<TFilters, TCtx> => Boolean(def))
    .filter((def) => !def.hidden?.(ctx))
}

export function resolveLeadFilterDef<TFilters, TCtx>(
  leadKey: string | undefined,
  definitions: FilterDefinition<TFilters, TCtx>[],
  ctx: TCtx,
): FilterDefinition<TFilters, TCtx> | undefined {
  if (!leadKey) return undefined
  const def = definitions.find((entry) => entry.key === leadKey)
  if (!def || def.hidden?.(ctx)) return undefined
  return def
}

export function excludeLeadFilterKeys(keys: readonly string[], lead?: string): string[] {
  if (!lead) return [...keys]
  return keys.filter((key) => key !== lead)
}
